import { NestedFilter } from '@@partner:types:graphql'

import React, { useCallback, useState } from 'react'
import { Nav, Navbar, Pagination } from 'rsuite'
import { generatePath, NavLink, useParams } from 'react-router-dom'

import { useQueryFeedbacks } from '@@partner:graphql/query/feedback/feedbacks.gql'

import { Message, Panel } from 'rsuite'
import { AddOutline } from 'react-ionicons'

import FeedbacksTable from './FeedbacksTable'
import ShopTopMenu from '@components/shop/ShopTopMenu'

import { useGridHelper } from '@@partner:helpers/crud/grid'
import { ROUTE_SHOPS_CREATE_SHOP } from '@@partner:config/routes'
import FeedbacksFilter from '@components/feedback/grid/FeedbacksFilter'

const DEFAULT_FILTER: NestedFilter = {
  and: [
    {
      fields: [ 'shop_id' ],
      op: 'not_null'
    },
    {
      fields: [ 'order_id' ],
      op: 'is_null'
    }
  ]
}

export default function ShopFeedbacksPage () {
  const { brandSlug } = useParams<any>()

  const [ filter, setFilter ] = useState<NestedFilter>(DEFAULT_FILTER)

  const {
    page,
    limit,
    defaultLimitOptions,
    tableSort,
    handlePageSelect,
    handleLimitSelect,
    handleSortColumn
  } = useGridHelper()

  const { data, loading, error } = useQueryFeedbacks({
    pager: {
      page,
      limit
    },
    sort: {
      fieldName: tableSort.fieldName,
      direction: tableSort.direction
    },
    filter
  })

  const feedbacks = data?.feedbacks.edges ?? []
  const pageInfo = data?.feedbacks.pageInfo

  const showPagination = pageInfo?.lastPage !== 1


  const handleFilterChanged = useCallback(
    (updatedFilter: NestedFilter) => {
      setFilter({
        and: [
          updatedFilter,
          DEFAULT_FILTER
        ]
      })
      handlePageSelect(1)
    },
    [ handlePageSelect ]
  )



  return (
    <div className="ShopFeedbacksPage">
      <h1 className="u-heading">Отзывы покупателей</h1>

      {error && (
        <Message
          showIcon
          type="error"
          header="При получении данных возникла ошибка!"
        >
          {error.message}
        </Message>
      )}
      <ShopTopMenu />

      <FeedbacksFilter onFilterChanged={handleFilterChanged} showShopFilter showOrderFilter={false} />

      <Panel
        shaded
        className='my-5'
      >
        {feedbacks && (
          <FeedbacksTable
            tableSort={tableSort}
            loading={loading}
            feedbacks={feedbacks}
            onSortColumn={handleSortColumn}
          />
        )}

        {showPagination && (
          <Pagination
            size="md"
            last
            first
            next
            prev
            ellipsis
            activePage={page}
            pages={pageInfo?.lastPage}
            total={pageInfo?.lastPage ?? 1}
            maxButtons={10}
            onSelect={handlePageSelect}
          />
        )}

      </Panel>
    </div>
  )
}